// extracted by mini-css-extract-plugin
export default {"loadingIconWrapper":"Loading_loadingIconWrapper__WpTfX","loadingIconWrapperDark":"Loading_loadingIconWrapperDark__PK5o0","rotateLoad":"Loading_rotateLoad__5+SOt"};